<template>
  <div class="countdown-container">
    <p class="countdown__label">{{ getTranslatedText("Expiration") }}</p>

    <div
      class="countdown countdown__value"
      :class="{ blinking: isBlinking }"
      :style="{ color: textColor }"
    >
      <p v-if="timeRemaining > 0">{{ formattedTime }}</p>
      <p v-else class="expired">{{ getTranslatedText("Event Expired") }}</p>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language-mixins";

export default {
  mixins: [languageMixins],
  props: {
    drawDate: {
      type: String,
      required: true,
    },
    betId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      timeRemaining: 0,
      intervalId: null,
      isBlinking: false,
    };
  },
  computed: {
    formattedTime() {
      const hours = Math.floor(this.timeRemaining / 3600);
      const minutes = Math.floor((this.timeRemaining % 3600) / 60);
      const seconds = this.timeRemaining % 60;

      // Return the time in the format: "hh min: mm sec: ss"
      return `${String(hours).padStart(2, "0")}h: ${String(minutes).padStart(
        2,
        "0"
      )}m: ${String(seconds).padStart(2, "0")}s`;
    },
    textColor() {
      return this.timeRemaining <= 120 && this.timeRemaining > 0
        ? "red"
        : "#4A4A4A";
    },
  },
  mounted() {
    this.calculateTimeRemaining();
    this.intervalId = setInterval(this.calculateTimeRemaining, 1000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {
    calculateTimeRemaining() {
      const targetDate = new Date(this.drawDate).getTime();
      const now = new Date().getTime();
      this.timeRemaining = Math.floor((targetDate - now) / 1000);

      this.isBlinking = this.timeRemaining <= 120 && this.timeRemaining > 0;

      if (this.timeRemaining < 0) {
        this.timeRemaining = 0;
        clearInterval(this.intervalId);
        this.$emit("bet-expired", this.betId);
      }
    },
  },
};
</script>

<style scoped>
.countdown-container {
  width: min(100%, 576px);
  margin-top: 10px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(254, 219, 0, 0.22);
  padding: 10px 15px;
}

.countdown__label {
  margin: 0;
  flex-shrink: 0;
  white-space: nowrap;
}

.countdown__value {
  margin: 0;
  white-space: nowrap;

  p {
    margin: 0;
  }
}

.expired {
  font-weight: bold;
  color: red;
}

.blinking {
  animation: blink 1s infinite;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
